import { IconRevert } from '@consta/icons/IconRevert';

import type { IAgNumberValueCellEditor } from './AgNumberValueCellEditingRenderer';
import { AgNumberValueCellEditingRenderer } from './AgNumberValueCellEditingRenderer';

import Style from './AgNumberValueCellEditingWithLoaderRenderer.module.css';

interface IAgNumberValueCellEditingWithLoaderRenderer extends IAgNumberValueCellEditor {
    isShowLoader: boolean;
}

export const AgNumberValueCellEditingWithLoaderRenderer = (props: IAgNumberValueCellEditingWithLoaderRenderer) => {
    const { isShowLoader, ...rest } = props;

    return (
        <div className={Style.agNumberWithLoader}>
            {isShowLoader && (
                <div className={Style.wrapperIcon}>
                    <IconRevert size="s" />
                </div>
            )}
            <AgNumberValueCellEditingRenderer {...rest} />
        </div>
    );
};

AgNumberValueCellEditingWithLoaderRenderer.displayName = 'AgNumberValueCellEditingWithLoaderRenderer';
